import { useContext } from 'react';
import { AccountContext } from '../../contexts/AccountContext';

export const useIsUserAuth = () => {
  const account = useContext(AccountContext);

  return !!Object.keys(account).length;
};
